import Vue from "vue";
import en from "@/mixins/languages/en.js";
import es from "@/mixins/languages/es.js";
import nor from "@/mixins/languages/nor.js";
import swe from "@/mixins/languages/swe.js";

const emitter = new Vue({
  mixins: [en, es, nor, swe],

  methods: {
    translate(prop, lang) {
      return this[lang][prop];
    },
    translateName(name, lang) {
      let aux = "";
      try {
        switch (name) {
          //Contribution
          case "Contribution":
            aux = this.translate("Contribution", lang);
            break;
          case "Progressive Summary Report":
            aux = this.translate("ProgressiveSummary", lang);
            break;
          case "Aggregate Report":
            aux = this.translate("AggregateReport", lang);
            break;
          //Payments
          case "PayOff Report":
            aux = this.translate("PayOffReport", lang);
            break;
          default:
            console.log("Unknown Report [" + name + "]");
            break;
        }
        return aux;
      } catch (e) {
        console.log("Error in translateName() " + e);
        return aux;
      }
    },
  },
});

export default emitter;
